var ol = require('openlayers');
// var _ = require('underscore');
var Utils = require('Utils');

var AVAIL_GEOM = [
    ol.geom.GeometryType.POLYGON,
    ol.geom.GeometryType.LINE_STRING
];

ol.interaction.OMJSModify = function(options) {
	ol.interaction.Modify.call(this, options);
    this.handleDragEvent   = ol.interaction.OMJSModify.handleDragEvent;
    this.handleDownEvent   = ol.interaction.OMJSModify.handleDownEvent;
    this.handleUpEvent     = ol.interaction.OMJSModify.handleUpEvent;
    this.handleEvent       = ol.interaction.OMJSModify.handleEvent;

    this.defaultDeleteCondition_ = function(mapBrowserEvent) {
        return mapBrowserEvent.type == ol.MapBrowserEventType.SINGLECLICK;
    };

    this.deleteCondition_ = options.deleteCondition ?
      options.deleteCondition : this.defaultDeleteCondition_;

    var that = this;

    /* массив со всеми точками для редактирования */
    this.vertexFeatures_ = [];

    this.snappedVertex_ = false;

    /* флаг, показывающий создаем ли мы сейчас новую вершину */
    this.creatingNewVertex_ = false;

    /* флаг, показывающий редактируется ли геометрия в рамках OMJSModify
        (нужно для того чтобы отличать когда геометрия редактируется из других
        interaction'ов) */
    this.modifying_now_ = false;

    /* флаг, меняется при .setActive(active) */
    this._active_ = true;

    /* проверка на тач */
    this.isTouch_ = Utils.isTouch();

    var white = [255, 255, 255, 1];
    var width = this.pixelTolerance_;

    /* Дефолтные стили взяты из ol.style.Style.defaultFunction */
    this.defaultFeatureStyle = new ol.style.Style({
      image: new ol.style.Circle({
        radius: 6,  /* различие между двумя стилями */
        fill: new ol.style.Fill({
          color: /*'#6666ff'*/'#0086b3'
        }),
        stroke: new ol.style.Stroke({
          color: white,
          width: 3
        })
      })
    });

    ol.interaction.OMJSModify.highlightedVertexStyle = 
    this.highlightedVertexStyle = new ol.style.Style({
      image: new ol.style.Circle({
        radius: width,  /* различие между двумя стилями */
        fill: new ol.style.Fill({
          color: /*'#6666ff'*/'#0086b3'
        }),
        stroke: new ol.style.Stroke({
          color: white,
          width: 3
        })
      })
    });

    this.custom_vertex_overlay_ = new ol.layer.Vector({
        source: new ol.source.Vector({
          useSpatialIndex: false,
          wrapX: !!options.wrapX
        }),
        style: options.style ? options.style :
            ol.interaction.Modify.getDefaultStyleFunction(),
        updateWhileAnimating: true,
        updateWhileInteracting: true
    });

    this.features_.forEach(function(_feature){
        _feature.on('change', function(event){
            if (event.type == 'change') {
                if (!that.modifying_now_) {
                    that.rerenderVertices();
                }
            }
        }); 
    });

    this.rerenderVertices();
};
ol.inherits(ol.interaction.OMJSModify, ol.interaction.Modify);

ol.interaction.OMJSModify.prototype.getCustomVertexOverlay = function(){
  return this.custom_vertex_overlay_;
};

ol.interaction.OMJSModify.prototype.createOrUpdateVertexFeature_ = function(coordinates){
    var vertexFeature;
    var that = this;

    if (!this.snappedVertex_) {
        vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new ol.Feature(new ol.geom.Point(coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        } else {
            var geometry = /** @type {ol.geom.Point} */ (vertexFeature.getGeometry());
            geometry.setCoordinates(coordinates);
        }
        if (this.creatingNewVertex_) {
            this.setHighlightStylesForFeature(vertexFeature);
        } else {
            vertexFeature.setStyle();
        }
    } else {
        var vertex_feature = this.snappedVertex_ || this.findVertexByCoords(coordinates);
        if (coordinates && vertex_feature) {
            that.setHighlightStylesForFeature(vertex_feature);
            vertex_feature.getGeometry().setCoordinates(coordinates);
        }
    }
};

ol.interaction.OMJSModify.prototype.createVertexFeature_ = function(start, end, segment_index){
    var feature,
        start_segment;

    if (segment_index == 0) {
        start_segment = new ol.Feature(new ol.geom.Point(start));
        this.custom_vertex_overlay_.getSource().addFeature(start_segment);
        this.vertexFeatures_.push(start_segment);
    }

    feature = new ol.Feature(new ol.geom.Point(end));
    this.custom_vertex_overlay_.getSource().addFeature(feature);
    this.vertexFeatures_.push(feature);

};

ol.interaction.OMJSModify.prototype.handlePointerAtPixel_ = function(pixel, map){
    var vertex_feature;

    var pixelCoordinate = map.getCoordinateFromPixel(pixel);
    var sortByDistance = function(a, b) {
      return ol.interaction.Modify.pointDistanceToSegmentDataSquared(pixelCoordinate, a) -
          ol.interaction.Modify.pointDistanceToSegmentDataSquared(pixelCoordinate, b);
    };

    var box = ol.extent.buffer(
        ol.extent.createOrUpdateFromCoordinate(pixelCoordinate),
        map.getView().getResolution() * this.pixelTolerance_);

    var rBush = this.rBush_;
    var nodes = rBush.getInExtent(box);
    if (nodes.length > 0) {
        nodes.sort(sortByDistance);
        var node = nodes[0];
        var closestSegment = node.segment;
        var vertex = ol.interaction.Modify.closestOnSegmentData(pixelCoordinate, node);
        var vertexPixel = map.getPixelFromCoordinate(vertex);
        var dist = ol.coordinate.distance(pixel, vertexPixel);
        if (dist <= this.pixelTolerance_) {
          var vertexSegments = {};

            if (
                node.geometry.getType() === ol.geom.GeometryType.CIRCLE 
                // TODO: MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX больше нет
                && node.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX
            ) {
              this.snappedToVertex_ = true;
              this.createOrUpdateVertexFeature_(vertex);
            } else {
                var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                var squaredDist1 = ol.coordinate.squaredDistance(vertexPixel, pixel1);
                var squaredDist2 = ol.coordinate.squaredDistance(vertexPixel, pixel2);
                dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                this.snappedToVertex_ = dist <= this.pixelTolerance_;

                if (this.snappedToVertex_) {
                    vertex = squaredDist1 > squaredDist2 ?
                        closestSegment[1] : closestSegment[0];

                    vertex_feature = this.snappedVertex_ = this.findVertexByCoords(vertex);
                    if (vertex_feature) {
                        this.setHighlightStylesForFeature(vertex_feature);
                        if (this.vertexFeature_) {
                            this.overlay_.getSource().removeFeature(this.vertexFeature_);
                            this.vertexFeature_ = false;
                        }
                        // this.vertexFeature_ = vertex_feature;
                    }
                } else {
                    this.snappedVertex_ = false;

                    this.resetHighlightStyles();
                    this.createOrUpdateVertexFeature_(vertex);
                }

            var segment;
            for (var i = 1, ii = nodes.length; i < ii; ++i) {
              segment = nodes[i].segment;
              if ((ol.coordinate.equals(closestSegment[0], segment[0]) &&
                  ol.coordinate.equals(closestSegment[1], segment[1]) ||
                  (ol.coordinate.equals(closestSegment[0], segment[1]) &&
                  ol.coordinate.equals(closestSegment[1], segment[0])))) {
                vertexSegments[ol.getUid(segment)] = true;
              } else {
                break;
              }
            }
          }

          vertexSegments[ol.getUid(closestSegment)] = true;
          this.vertexSegments_ = vertexSegments;
          return;
        }
    }

    if (!vertex_feature) {
        this.resetHighlightStyles();
    }

    if (this.vertexFeature_) {
      this.overlay_.getSource().removeFeature(this.vertexFeature_);
      this.vertexFeature_ = null;
    }

    if (this.snappedVertex_) {
        this.snappedVertex_ = null;
        this.resetHighlightStyles();
    }
};

ol.interaction.OMJSModify.handleDownEvent = function(evt) {
    if (!this.condition_(evt)) {
        return false;
    }

    this.modifying_now_ = true;

    this.dragSegments_.length = 0;
    this.modified_ = false;

    var newVertexFeature_ = this.vertexFeature_ || this.snappedVertex_;


    if (!this.snappedVertex_ && this.vertexFeature_) {
    /* если мы кликнули не на снэпнутой вершине,
        то мы создаем новую точку. Нужно об этом дать знать функции  */
        this.creatingNewVertex_ = true;
    } else {
        this.creatingNewVertex_ = false;
    }

    this.handlePointerAtPixel_(evt.pixel, evt.map);

    /* хак для тачей потому что vertexFeature_ появится на тачах только 
        полсе выполнения функции handlePointerAtPixel_ */
    if (this.isTouch_) {
        newVertexFeature_ = this.vertexFeature_ || this.snappedVertex_;

        if (!this.snappedVertex_ && this.vertexFeature_) {
        /* если мы кликнули не на снэпнутой вершине,
            то мы создаем новую точку. Нужно об этом дать знать функции  */
            this.creatingNewVertex_ = true;
        } else {
            this.creatingNewVertex_ = false;
        }
    }


  // var vertexFeature_backup = this.vertexFeature_;
  // this.vertexFeature_ = newVertexFeature_;


  var vertexFeature = newVertexFeature_;
  if (vertexFeature) {
    var insertVertices = [];
    var geometry = /** @type {ol.geom.Point} */ (vertexFeature.getGeometry());
    var vertex = geometry.getCoordinates();
    var vertexExtent = ol.extent.boundingExtent([vertex]);
    var segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
    var componentSegments = {};
    segmentDataMatches.sort(ol.interaction.Modify.compareIndexes_);
    for (var i = 0, ii = segmentDataMatches.length; i < ii; ++i) {
      var segmentDataMatch = segmentDataMatches[i];
      var segment = segmentDataMatch.segment;
      var uid = ol.getUid(segmentDataMatch.feature);
      var depth = segmentDataMatch.depth;
      if (depth) {
        uid += '-' + depth.join('-'); // separate feature components
      }
      if (!componentSegments[uid]) {
        componentSegments[uid] = new Array(2);
      }
      if (segmentDataMatch.geometry.getType() === ol.geom.GeometryType.CIRCLE &&
      segmentDataMatch.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CIRCUMFERENCE_INDEX) {

        var closestVertex = ol.interaction.Modify.closestOnSegmentData(vertex, segmentDataMatch);
        if (ol.coordinate.equals(closestVertex, vertex) && !componentSegments[uid][0]) {
          this.dragSegments_.push([segmentDataMatch, 0]); 
          componentSegments[uid][0] = segmentDataMatch;
        }
      } else if (ol.coordinate.equals(segment[0], vertex) &&
          !componentSegments[uid][0]) {
        this.dragSegments_.push([segmentDataMatch, 0]);
        componentSegments[uid][0] = segmentDataMatch;
      } else if (ol.coordinate.equals(segment[1], vertex) &&
          !componentSegments[uid][1]) {

        // prevent dragging closed linestrings by the connecting node
        if ((segmentDataMatch.geometry.getType() ===
            ol.geom.GeometryType.LINE_STRING ||
            segmentDataMatch.geometry.getType() ===
            ol.geom.GeometryType.MULTI_LINE_STRING) &&
            componentSegments[uid][0] &&
            componentSegments[uid][0].index === 0) {
          continue;
        }

        this.dragSegments_.push([segmentDataMatch, 1]);
        componentSegments[uid][1] = segmentDataMatch;
      } else if (ol.getUid(segment) in this.vertexSegments_ &&
          (!componentSegments[uid][0] && !componentSegments[uid][1])) {
        insertVertices.push([segmentDataMatch, vertex]);
      }
    }
    if (insertVertices.length) {
      this.willModifyFeatures_(evt);
    }
    for (var j = insertVertices.length - 1; j >= 0; --j) {
      this.insertVertex_.apply(this, insertVertices[j]);
    }
  }

  if (!this.isTouch_ && !newVertexFeature_) {
    this.modifying_now_ = false;
  }

    return !!newVertexFeature_;

  // this.vertexFeature_ = vertexFeature_backup;
};

ol.interaction.OMJSModify.handleDragEvent = function(evt){
    this.ignoreNextSingleClick_ = false;
    this.willModifyFeatures_(evt);

    var vertex = evt.coordinate;
    for (var i = 0, ii = this.dragSegments_.length; i < ii; ++i) {
      var dragSegment = this.dragSegments_[i];
      var segmentData = dragSegment[0];
      var depth = segmentData.depth;
      var geometry = segmentData.geometry;
      var coordinates;
      var segment = segmentData.segment;
      var index = dragSegment[1];

      while (vertex.length < geometry.getStride()) {
        vertex.push(segment[index][vertex.length]);
      }

      switch (geometry.getType()) {
        case ol.geom.GeometryType.POINT:
          coordinates = vertex;
          segment[0] = segment[1] = vertex;
          break;
        case ol.geom.GeometryType.MULTI_POINT:
          coordinates = geometry.getCoordinates();
          coordinates[segmentData.index] = vertex;
          segment[0] = segment[1] = vertex;
          break;
        case ol.geom.GeometryType.LINE_STRING:
          coordinates = geometry.getCoordinates();
          coordinates[segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;
        case ol.geom.GeometryType.MULTI_LINE_STRING:
          coordinates = geometry.getCoordinates();
          coordinates[depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;
        case ol.geom.GeometryType.POLYGON:
          coordinates = geometry.getCoordinates();
          coordinates[depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;
        case ol.geom.GeometryType.MULTI_POLYGON:
          coordinates = geometry.getCoordinates();
          coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;
        case ol.geom.GeometryType.CIRCLE:
          segment[0] = segment[1] = vertex;
          if (segmentData.index === ol.interaction.Modify.MODIFY_SEGMENT_CIRCLE_CENTER_INDEX) {
            this.changingFeature_ = true;
            geometry.setCenter(vertex);
            this.changingFeature_ = false;
          } else { // We're dragging the circle's circumference:
            this.changingFeature_ = true;
            geometry.setRadius(ol.coordinate.distance(geometry.getCenter(), vertex));
            this.changingFeature_ = false;
          }
          break;
        default:
          // pass
      }

      if (coordinates) {
        this.setGeometryCoordinates_(geometry, coordinates);
      }
    }
    this.createOrUpdateVertexFeature_(vertex);
};

ol.interaction.OMJSModify.handleUpEvent = function(evt){

    this.modifying_now_ = false;

    // TODO: тут все точки перегенерируются. Возможно, есть способ добавить
    //  нужную вершину в нужное место чтоб не перегенерировать все это?
    if (this.creatingNewVertex_) {
        /* если мы создаем новую вершину, то нам нужно удалить this.vertexFeature_
            и сгенерировать все точки  */    
        this.rerenderVertices();
    }
    this.creatingNewVertex_ = false;

    if (this.isTouch_) {
        if (this.vertexFeature_) {
          this.overlay_.getSource().removeFeature(this.vertexFeature_);
          this.vertexFeature_ = null;
        }

        if (this.snappedVertex_) {
            this.snappedVertex_ = null;
            this.resetHighlightStyles();
        }
    }

    return ol.interaction.Modify.prototype.handleUpEvent.call(this, evt);
};

ol.interaction.OMJSModify.handleEvent = function(mapBrowserEvent){
    if (this._active_) {
        if (!(mapBrowserEvent instanceof ol.MapBrowserPointerEvent)) {
          return true;
        }
        this.lastPointerEvent_ = mapBrowserEvent;

        var handled;
        if (
            !mapBrowserEvent.map.getView().getHints()[ol.ViewHint.INTERACTING] 
            && mapBrowserEvent.type == ol.MapBrowserEventType.POINTERMOVE 
            && !this.handlingDownUpSequence
        ) {
          this.handlePointerMove_(mapBrowserEvent);
        }
        if (
            (this.vertexFeature_ || this.snappedVertex_) 
            && this.deleteCondition_(mapBrowserEvent)
        ) {
          if (mapBrowserEvent.type != ol.MapBrowserEventType.SINGLECLICK ||
              !this.ignoreNextSingleClick_) {
            handled = this.removePoint();
          } else {
            handled = true;
          }
        }

        if (mapBrowserEvent.type == ol.MapBrowserEventType.SINGLECLICK) {
          this.ignoreNextSingleClick_ = false;
        }

        return ol.interaction.Pointer.prototype.handleEvent.call(this, mapBrowserEvent) &&
            !handled;
    }

    return true;
};

ol.interaction.OMJSModify.prototype.removePoint = function(){
    var features = this.features_;
    var _result = ol.interaction.Modify.prototype.removePoint.call(this);
    this.dispatchEvent(new ol.interaction.Modify.Event(
    	'removepoint',
    	features
    ));
    return _result;
};

ol.interaction.OMJSModify.prototype.setStylesForFeaturesAtPixel = function(map, pixel){
    var that = this;
    var feature_geom;
    map.forEachFeatureAtPixel(pixel, function(feature){
        if (feature && that.vertexFeatures_.indexOf(feature) !== -1) {
            feature_geom = feature.getGeometry();
            if (feature_geom.getType() == ol.geom.GeometryType.POINT) {
                feature.setStyle([that.highlightedVertexStyle]);
            }
        } else {
            that.resetHighlightStyles();
        }
    });
};

ol.interaction.OMJSModify.prototype.setHighlightStylesForFeature = function(feature){
    feature.setStyle([this.highlightedVertexStyle]);
};

ol.interaction.OMJSModify.prototype.resetHighlightStyles = function(){
    this.vertexFeatures_.forEach(function(vertex){
        vertex.setStyle();
    });
};

ol.interaction.OMJSModify.prototype.findVertexByCoords = function(coords) {
    var filtered_vertex = this.vertexFeatures_.filter(function(vertex){
        var vertex_geom = vertex.getGeometry();
        var vertex_coords = vertex_geom.getCoordinates();
        return (
            vertex_coords[0] == coords[0] &&
            vertex_coords[1] == coords[1]
        );
    });
    return filtered_vertex[0];
};

ol.interaction.OMJSModify.prototype.setActive = function(active){
    var that = this;
    that._active_ = !!active;
    ol.interaction.Pointer.prototype.setActive.call(this, active);
    // ol.interaction.Modify.prototype.setActive.call(this, active);
};

ol.interaction.OMJSModify.prototype.setMap = function(map) {
    var that = this;
    that.custom_vertex_overlay_.setMap(map);
    ol.interaction.Modify.prototype.setMap.call(this, map);
    
};

ol.interaction.OMJSModify.prototype.forEachSegment = function(geom, callback, opt_this){
    var geom_type = geom.getType();
    if (geom_type == ol.geom.GeometryType.LINE_STRING) {
        return geom.forEachSegment(callback, opt_this);
    } else if (geom_type == ol.geom.GeometryType.POLYGON) {
        var flat_coords = geom.getOrientedFlatCoordinates();
        return ol.geom.flat.segments.forEach(flat_coords.slice(0, flat_coords.length - 1), 0,
            geom.flatCoordinates.length, geom.stride, callback, opt_this); 
    } else {
        // pass
    }
};

ol.interaction.OMJSModify.prototype.rerenderVertices = function(){
    var that = this;
    this.custom_vertex_overlay_.getSource().clear();
    that.vertexFeatures_.length = 0;
    this.features_.forEach(function(_feature){
        var feature_geom = _feature.getGeometry();

        /* Если редактируем геометрию не линию и не полигон, то
            ничего с сегментами не делаем */
        if (AVAIL_GEOM.indexOf(feature_geom.getType()) == -1) return;

        var segment_counter = 0;
        that.forEachSegment(feature_geom, function(start, end){
            that.createVertexFeature_(start, end, segment_counter);
            segment_counter++; 
        });
    });
};
// ol.interaction.OMJSModify.prototype.rerenderVertices = 
//     _.throttle(ol.interaction.OMJSModify.prototype.rerenderVertices_, 10); 

ol.interaction.OMJSModify.AVAILABLE_GEOMTYPES = AVAIL_GEOM;


//////////////////
// WEBPACK FOOTER
// ./src/View/OMJSModifyInteraction.js
// module id = 229
// module chunks = 0